import React, { memo } from 'react';
import cn from 'classnames';

import { AdaptiveTableCell, DynamicIconWrapper } from '@components/common';

import { Icons } from '@icons/icons';

import colors from '@constants/colors';

import styles from './ViewActionTableCell.module.scss';

interface IViewActionTableCell {
	onClick: () => void;
	text: string;
	tooltipLabel?: string;
	styleInline?: React.CSSProperties;
	className?: string;
	isCentered?: boolean;
	isDisabled?: boolean;
}

const activeStyle = {
	color: colors.indigo50,
	textDecoration: 'underline',
	cursor: 'pointer',
	padding: '10px 0px',
};

const disabledStyle = {
	color: colors.indigo70,
	textDecoration: 'none',
	cursor: 'default',
	padding: '10px 0px',
};

const ViewActionTableCell = ({
	onClick,
	text,
	tooltipLabel,
	styleInline = {},
	className = '',
	isCentered = false,
	isDisabled = false,
}: IViewActionTableCell) => {
	const cellClassName = cn(styles.wrapper, className, { [styles.centered]: isCentered });

	const handleClick = () => {
		if (isDisabled) return;

		onClick();
	};

	const cellStyle = isDisabled ? disabledStyle : activeStyle;

	return (
		<div className={cellClassName}>
			<AdaptiveTableCell
				onClick={handleClick}
				styleInline={{
					...cellStyle,
					...styleInline,
				}}
				text={text}
			/>
			<DynamicIconWrapper
				icon={Icons.viewIcon}
				isDisabled={isDisabled}
				onClick={onClick}
				tooltipLabel={tooltipLabel}
			/>
		</div>
	);
};

export default memo(ViewActionTableCell);
